import { handleConnectionException } from './handleConnectionException';
import { handleServerException } from './handleServerException';
import { handleUncaughtException } from './handleUncaughtException';

// eslint-disable-next-line import/prefer-default-export
export function handleException(
  exception,
  callbackActionCreator,
  showAlert = false,
  showNetworkErrorAlert = true
) {
  if (exception instanceof ErrorEvent) {
    return handleUncaughtException(exception, callbackActionCreator, showAlert);
  }
  if (exception.response) {
    return handleServerException(exception.response, callbackActionCreator, showAlert);
  }

  return handleConnectionException(exception, callbackActionCreator, showNetworkErrorAlert);
}
